<app-navbar-style-two></app-navbar-style-two>

<!-- Banner Section -->
<div class="inner-banner" *ngIf="blog">
  <div class="container">
    <div class="inner-title text-center">
      <h3>{{ blog.title }}</h3>
      <ul class="inner-list">
        <li><i class="bx bx-user"></i> {{ blog.author }}</li>
        <li>
          <i class="bx bx-calendar"></i> {{ blog.date | date : "longDate" }}
        </li>
      </ul>
    </div>
  </div>
  <div class="inner-banner-shape">
    <div class="shape-one">
      <img src="assets/img/inner-banner/banner-shape1.png" alt="Images" />
    </div>
    <div class="shape-two">
      <img src="assets/img/inner-banner/banner-shape2.png" alt="Images" />
    </div>
    <div class="shape-three">
      <img src="assets/img/inner-banner/banner-shape3.png" alt="Images" />
    </div>
    <div class="inner-banner-dots-2">
      <img src="assets/img/shape/dots-shape.png" alt="Images" />
    </div>
  </div>
</div>

<!-- Loading/Error States -->
<div *ngIf="loading" class="text-center py-5">
  <div class="spinner">
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
  </div>
  <p class="mt-3">Loading blog post...</p>
</div>
<div *ngIf="error" class="alert alert-danger text-center my-5">
  <i class="fas fa-exclamation-circle me-2"></i>
  Blog post not found or failed to load.
</div>

<!-- Blog Details -->
<div class="blog-details-area pb-70" *ngIf="blog && !loading && !error">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-12">
        <div class="blog-article">
          <div class="blog-article-img mb-4">
            <img [src]="blog.image" [alt]="blog.title" />
          </div>
          <div class="article-content">
            <!-- <div [innerHTML]="blog.content"></div> -->
            <div #contentContainer [innerHTML]="highlightedContent"></div>
          </div>
          <div class="blog-article-share mt-4">
            <div class="row align-items-center">
              <div class="col-lg-7 col-sm-6 col-md-7">
                <div class="blog-tag">
                  <ul>
                    <li>Tags:</li>
                    <li *ngFor="let tag of blog.tags">
                      <a href="javascript:void(0)">#{{ tag }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-5 col-sm-6 col-md-5">
                <ul class="social-icon">
                  <li>
                    <a target="_blank" href="#"
                      ><i class="bx bxl-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a target="_blank" href="#"
                      ><i class="bx bxl-twitter"></i
                    ></a>
                  </li>
                  <li>
                    <a target="_blank" href="#"
                      ><i class="bx bxl-instagram"></i
                    ></a>
                  </li>
                  <li>
                    <a target="_blank" href="#"
                      ><i class="bx bxl-linkedin"></i
                    ></a>
                  </li>
                  <li>
                    <a target="_blank" href="#"
                      ><i class="bx bxl-youtube"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12">
        <div class="blog-widget-left">
          <div class="blog-widget">
            <h3 class="title">Search</h3>

            <div class="search-widget">
              <!-- <form class="search-form">
                                <input type="search" class="form-control" placeholder="Search...">
                                <button type="submit"><i class="bx bx-search"></i></button>
                            </form> -->
              <form class="search-form" (submit)="onSearch()">
                <input
                  type="search"
                  class="form-control"
                  placeholder="Search..."
                  [(ngModel)]="searchTerm"
                  name="searchTerm"
                />
                <button type="submit"><i class="bx bx-search"></i></button>
              </form>
            </div>
          </div>

          <div class="blog-widget">
            <h3 class="title">Recent Posts</h3>

            <div class="widget-popular-post">
              <article class="item">
                <!-- <a routerLink="/blog" class="thumb"><span class="full-image cover bg1" role="img"></span></a> -->
                <div class="info">
                  <!-- <span>May 29, 2025</span>  -->
                  <h4 class="title-text">
                    <a
                      routerLink="/blogs/top-10-must-have-features-in-modern-inbound-call-center-software"
                      >Top 10 Must-Have Features in Modern Inbound Call Center
                      Software</a
                    >
                  </h4>
                  <p>
                    Inbound Call Center Software, Call Routing, IVR, CRM
                    Integration
                    <a
                      routerLink="/blogs/top-10-must-have-features-in-modern-inbound-call-center-software"
                      class="ms-1 text-primary text-decoration-underline"
                      >Read More</a
                    >
                  </p>
                </div>
              </article>

              <article class="item">
                <!-- <a routerLink="/blog" class="thumb"><span class="full-image cover bg2" role="img"></span></a> -->
                <div class="info">
                  <!-- <span>May 27, 2025</span> -->
                  <h4 class="title-text">
                    <a
                      routerLink="/blogs/why-legal-call-centers-need-preview-dialers-for-better-client-engagement"
                      >Why Legal Call Center Need Preview Dialers for Better
                      Client Engagement</a
                    >
                  </h4>
                  <p>
                    Legal Call Center, Preview Dialer, Client Engagement,
                    Compliance
                    <a
                      routerLink="/blogs/why-legal-call-centers-need-preview-dialers-for-better-client-engagement"
                      class="ms-1 text-primary text-decoration-underline"
                      >Read More</a
                    >
                  </p>
                </div>
              </article>

              <article class="item">
                <!-- <a routerLink="/blog" class="thumb"><span class="full-image cover bg3" role="img"></span></a> -->
                <div class="info">
                  <!-- <span>May 27, 2025</span> -->
                  <h4 class="title-text">
                    <a
                      routerLink="/blogs/power-dialers-for-startups-scaling-sales-without-scaling-costs"
                      >Power Dialers for Startups: Scaling Sales Without Scaling
                      Costs</a
                    >
                  </h4>
                  <p>
                    Power Dialer, Startup Sales, Outbound Calling, CRM
                    Integration
                    <a
                      routerLink="/blogs/power-dialers-for-startups-scaling-sales-without-scaling-costs"
                      class="ms-1 text-primary text-decoration-underline"
                      >Read More</a
                    >
                  </p>
                </div>
              </article>
            </div>
          </div>

          <!-- Categories Widget -->
          <div class="blog-widget">
            <h3 class="title">Categories</h3>

            <div class="widget_categories">
              <ul>
                <li [class.active]="selectedCategory === null">
                  <a href="javascript:void(0)" (click)="filterByCategory(null)">
                    All Categories
                    <span class="count">({{ blogs.length }})</span>
                  </a>
                </li>
                <li
                  *ngFor="let category of categories"
                  [class.active]="selectedCategory === category.name"
                >
                  <a
                    href="javascript:void(0)"
                    (click)="filterByCategory(category.name)"
                  >
                    {{ category.name }}
                    <span class="count">({{ category.count }})</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Popular Tags -->
          <div class="blog-widget">
            <h3 class="title">Popular Tags</h3>
            <div class="tagcloud blog-widget-tag">
              <a href="javascript:void(0)" *ngFor="let tag of getPopularTags()">
                {{ tag }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-style-two></app-footer-style-two>
